import { useFilterPossiblyMaliciousPositions } from './useFilterPossiblyMaliciousPositions';
import { useV3Positions } from './useV3Positions';
import { useWeb3React } from './useWeb3React';
import type { PositionDetails } from 'types/position';

import { useStakerOwnerTokenIds } from 'graphql/api/positions/positions.hooks';

type usePositionsProps = {
  chainId: number;
};

export const usePositions = ({ chainId }: usePositionsProps) => {
  const { account } = useWeb3React();

  const { data: tokenIds } = useStakerOwnerTokenIds({
    chainId,
    address: account
  });

  const { positions, loading } = useV3Positions(account, tokenIds);

  const [openPositions] = positions?.reduce<
    [PositionDetails[], PositionDetails[]]
  >(
    (acc, p) => {
      acc[p.liquidity?.isZero() ? 1 : 0].push(p);
      return acc;
    },
    [[], []]
  ) ?? [[], []];

  const filteredPositions = useFilterPossiblyMaliciousPositions(openPositions);

  return { positions: filteredPositions, loading };
};
